import { extracted_params, extractUrlQueryOnMessage } from "./UrlFilter";


// Filter methods
const rangeFilterChangedFromDefault = (
    parameter_name: string,
    range_parameter: Array<number>
) => {
    let range_filters_default = {};
    Object.keys(window.Configs.filters).map((key) => {
        if (window.Configs.filters[key]["type"] == "range") {
            range_filters_default[key] = [
                window.Configs.filters[key]["min"],
                window.Configs.filters[key]["max"]
            ]
        }
    });

    return (
        range_parameter[0] > range_filters_default[parameter_name][0]
        || range_parameter[1] < range_filters_default[parameter_name][1]
    );
};

const applyFiltersToCards = (
    parameter_name: string,
    parameter: Array<number> | any,
    cards_list: any
) => {
    let filtered_list = [];
 
    for (let entry of cards_list) {
        if (Array.isArray(parameter)) {
            if (
                entry["specs"][parameter_name]["value"] >= parameter[0] &&
                entry["specs"][parameter_name]["value"] <= parameter[1]    
            ) {
                filtered_list.push(entry);
            }
        } else {
            for (let value of entry["specs"][parameter_name]["value"]) {
                if (parameter[value] && !filtered_list.includes(entry))
                    filtered_list.push(entry);
            }
        }
    }

    return filtered_list;
};

const countCheckboxFilter = (cards_list) => {
    let counts = {};

    for (let card of cards_list) {
        Object.keys(card['specs']).map((key) => {
            let label = card['specs'][key]['key'];
            let value = card['specs'][key]['value'];
            
            if (key != "hidden_info") {
                if (Array.isArray(value)) {
                    if (!counts.hasOwnProperty(key))
                        counts[key] = {};

                    value.map((filter_val) => {
                        if (!counts[key].hasOwnProperty(filter_val))
                            counts[key][filter_val] = 1;

                        else
                            counts[key][filter_val] += 1;
                    });
                };
            };
        });
    };

    return counts;
};


export const FilterUtils = {
    // url query
    extracted_params,
    extractUrlQueryOnMessage,

    // methods
    applyFiltersToCards,
    rangeFilterChangedFromDefault,
    countCheckboxFilter,
};